import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import settings from '../../../Settings/Settings'
export default function OrderInformation(props) {
    const [orderInformation, setOrderInformation] = React.useState(null)
    const [loadedOrderInformation, setLoadedOrderInformation] = React.useState(false)
    useEffect(() => {
        getOrderInformationAction()
        }, []);

    const classes = {
        root: {
            display: 'block',
            maxWidth: '750px',
            margin: '70px auto',
            padding: '8px',
            '& > *': {
            margin: 1,
            width: 16,
            height: 16,
            },
        },
        img: {
            maxWidth: '150px',
            maxHeight: '150px'
        },
        proceedToCheckout: {
            textDecoration: 'none',
            display: "block",
            margin: "0 5px",
            width: "100%",
            color: 'inherit'
            }
        };
    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods
      }
      const componentProps = {
          ...props.componentProps
      }
    const getOrderInformationAction = () => {
        let endpoint = settings.API_ENDPOINT_ORDER_INFORMATION + props.element.ordersID + '/' + props.element.ordersSha
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }
            endpoint += accountToken
            componentMethods.ajax(settings.API_URL + endpoint,{},"GET", null, 
                (data) => {
                    if(data.items.length) {
                        setOrderInformation(data.items[0])
                        setLoadedOrderInformation(true)
                    }
            })
    }
    if(!loadedOrderInformation)
        return null
return (<React.Fragment>
    <Typography variant="subtitle1" gutterBottom>
        {componentConstants.language.LANG_FIRM_NAME}: <b>{orderInformation.shopFirmsName}</b> <br />
        {componentConstants.language.LANG_CREATE_ACCOUNT_CIF}: <b>{orderInformation.shopFirmsCif}</b> <br />
        {componentConstants.language.LANG_CREATE_ACCOUNT_NO_ORC}: <b>{orderInformation.shopFirmsOrcNumber}</b> <br />
        {componentConstants.language.LANG_CREATE_ACCOUNT_FIRM_ADDRESS}: <b>{orderInformation.shopFirmsAddress}</b> <br />
        {componentConstants.language.LANG_CREATE_ACCOUNT_FIRM_BANK}: <b>{orderInformation.shopFirmsBank}</b>
    </Typography>
</React.Fragment>
  );
}